// KPI Type configuration
export const DEFAULT_KPI_GLOBAL_PERFORMANCE_TYPE = "area";
export const DEFAULT_KPI_COMPLIANCE_TYPE = "total";
export const DEFAULT_GDA_KPI_TYPE = "area";
export const DEFAULT_CHART_ORIENTATION = "vertical";
// Chart display options
export const CHART_MAX_DECIMAL_PLACES = 3;
export const CHART_MIN_DECIMAL_PLACES = 0;
// Brand colors for charts
export const CHART_COLORS = [
    "#2655CE",
    "#C87611",
    "#5D40B0",
    "#17A673",
    "#F7C74D",
    "#D61C6A",
    "#3C6EF2",
    "#E58E28",
    "#7A5DCC",
    "#1FC98C",
    "#FFD86A",
    "#F13C89",
];
